export const mainSiteLink:string = 'https://akbars-dom.ru/'
